export enum AppTypes {
  'Стандартная' = 1,
  'Денежная',
}
